
export const customerGroupCodes = {
  CUSTOMER: 'CUST',
  VENDOR: 'VND',
}
